import { CheckIcon } from '@medeloop/medeloop-components-library';
import { motion } from 'motion/react';
import { MaterialSymbol } from 'react-material-symbols';

export const ActionButtons = ({
  onAccept,
  onEdit,
}: {
  onAccept: () => void;
  onEdit: () => void;
}) => {
  return (
    <motion.div
      className="flex flex-row gap-2 mt-4"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.5, duration: 0.4 }}
    >
      <button
        className="bg-primary-background-default hover:bg-primary-background-hover text-black font-medium px-3 rounded-full text-sm h-fit py-2 border border-stroke-on-dark-subdued"
        onClick={onAccept}
      >
        <div className="flex flex-row items-center">
          <CheckIcon className="w-5 h-5 mr-1" />
          <span>Accept</span>
        </div>
      </button>
      <button
        className="text-white font-medium px-3 rounded-full text-sm h-fit py-2 border border-stroke-on-dark-subdued hover:bg-white/5"
        onClick={onEdit}
      >
        <div className="flex flex-row items-center justify-center">
          <MaterialSymbol icon="edit" className="w-5 h-5 mr-1" />
          <span>Edit</span>
        </div>
      </button>
    </motion.div>
  );
};
